// export const AccrRequestFixedColumns: Partial<ITableColumnConfig>[] = [

import { ITableColumnConfig } from '../../../components/DataTable/IDataTable';

export const ACCR_REQUEST_COLUMNS: ITableColumnConfig[] = [
  {
    dataField: 'requestId',
    headerLabel: 'REQUEST_ID',
    component: 'renderRequestId',
    type: 'custom',
    cellSize: 3,
  },
  {
    dataField: 'status',
    headerLabel: 'REQUEST_STATUS',
    type: 'custom',
    component: 'renderStatus',
    cellSize: 2,
  },
  {
    dataField: 'dataCompletedPercentage',
    headerLabel: 'DATA_LABEL',
    type: 'custom',
    component: 'renderDataCompletedPercentage',
    cellSize: 2,
  },

  {
    headerLabel: 'EMAIL',
    dataField: 'email',
    type: 'text',
    cellSize: 3,
  },
  {
    headerLabel: 'FIRSTNAME',
    dataField: 'firstName',
    type: 'text',
    cellSize: 3,
  },
  {
    dataField: 'lastName',
    headerLabel: 'LASTNAME',
    type: 'text',
    cellSize: 3,
  },
  // {
  //   dataField: 'surNameAtBirth',
  //   headerLabel: 'SURNAMEATBIRTH',
  // },
  {
    dataField: 'gender',
    headerLabel: 'GENDER',
    type: 'text',
    cellSize: 2,
  },
  // TODO, GET organisation name based on the id
  // {
  //   dataField: 'organisation',
  //   headerLabel: 'ORGANISATION',
  //   sorting: false,
  // },

  {
    dataField: 'dateOfBirth',
    headerLabel: 'DATEOFBIRTH',
    type: 'text',
    cellSize: 2,
  },

  // {
  //   dataField: 'placeOfBirth',
  //   headerLabel: 'PLACEOFBIRTH',
  //   type: 'text',
  // },
  {
    dataField: 'countryOfBirth',
    headerLabel: 'COUNTRYOFBIRTH',
    type: 'text',
    cellSize: 2,
  },
  {
    dataField: 'eventNames',
    headerLabel: 'EVENTS',
    component: 'renderEventNames',
    type: 'custom',
    cellSize: 3,
  },

  // {
  //   dataField: 'category',
  //   headerLabel: 'CATEGORY',
  //
  //   cellStyle: {
  //     minWidth: 200,
  //   },
  // },
  // {
  //   dataField: 'subcategory',
  //   headerLabel: 'SUBCATEGORY',
  //
  //   cellStyle: {
  //     minWidth: 200,
  //   },
  // },
  // {
  //   dataField: 'nameAtBirth',
  //   headerLabel: 'NAME_AT_BIRTH',
  //
  //   scopes: [SCOPES.READ_PII],
  // },
  // {
  //   dataField: 'previousNames',
  //   headerLabel: 'PREVIOUS_NAMES',
  //
  //   scopes: [SCOPES.READ_PII],
  //   cellStyle: {
  //     minWidth: 120,
  //   },
  // },
  // {
  //   dataField: 'validDurations',
  //   headerLabel: 'CREDENTIALS.DAYPASS_VALIDITY',
  //   type: 'text',

  // },
  // {
  //   dataField: 'employeeNumber',
  //   headerLabel: 'EMPLOYEENUMBER',
  //   type: 'text',
  // },
  // {
  //   dataField: 'headerLabel',
  //   headerLabel: 'ROLE_LABEL',
  //   type: 'text',

  // },
  // {
  //   dataField: 'jobTitle',
  //   headerLabel: 'JOB_TITLE',
  //   type: 'text',

  // },
  // {
  //   dataField: 'department',
  //   headerLabel: 'PUBLISHED_MEDIUM',
  //   type: 'text',

  // },

  // // {
  // //   dataField: 'requestedBy',
  // //   headerLabel: 'REQUESTED_BY',
  // // },
  // // {
  // //   dataField: 'accessNeeds',
  // //   headerLabel: 'ACCESS_NEEDS',
  // // },
  // {
  //   dataField: 'addressExtraInfo',
  //   headerLabel: 'NOTES',
  //   type: 'text',

  // },
  // // {
  // //   dataField: 'eventIds',
  // //   headerLabel: 'DAYS_ONSITE',
  // // },

  // {
  //   dataField: 'nationalities',
  //   headerLabel: 'NATIONALITY',
  //   type: 'text',
  // },
  // {
  //   dataField: 'documentNumber',
  //   headerLabel: 'PRESS_ID',
  //   type: 'text',

  // },
  // {
  //   dataField: 'documentType',
  //   headerLabel: 'DOCUMENT_TYPE',
  //   type: 'text',

  // },
  // {
  //   headerLabel: 'MOBILENUMBER',
  //   dataField: 'mobileNumber',
  //   type: 'text',

  // },

  // {
  //   dataField: 'addressLine',
  //   headerLabel: 'ADDRESS_LINE',

  //   type: 'text',

  // },
  // {
  //   dataField: 'addressCity',
  //   headerLabel: 'ADDRESS_CITY',
  //   type: 'text',

  // },
  // {
  //   dataField: 'addressZipCode',
  //   headerLabel: 'ZIP_CODE',
  //   type: 'text',

  // },
  // {
  //   dataField: 'addressCountry',
  //   headerLabel: 'ADDRESS_COUNTRY',
  //   type: 'text',

  // },

  // {
  //   dataField: 'nativeResident',
  //   headerLabel: 'NATIVE_RESIDENT',
  //   type: 'text',

  // },
  // {
  //   dataField: 'state',
  //   headerLabel: 'STATE',
  //   type: 'text',

  // },
  // {
  //   dataField: 'federalStates',
  //   headerLabel: 'FEDERAL_STATE',
  //   type: 'text',

  // },
  // {
  //   dataField: 'functionName',
  //   headerLabel: 'FUNCTION',
  //   type: 'text',

  // },
  // {
  //   dataField: 'agreementChecked',
  //   headerLabel: 'AGREEMENT_TERMS_AND_CONDITIONS',
  //   type: 'text',

  // },
  // {
  //   dataField: 'consentChecked',
  //   headerLabel: 'CONSENT_ZVU',
  //   type: 'text',

  // },
];
